import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import { IoMdClose } from "react-icons/io";
import { VscSyncIgnored } from "react-icons/vsc";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { clearTasksToSync } from "../../../../config/redux/slices/schedulerSlice";
import { selectDailyTasksToSync } from "../../../../config/redux/slices/schedulerSlice/selectors";

const ClearSyncDialog = ({ visible, setVisible }) => {
  const dispatch = useDispatch();
  const tasksToSync = useSelector(selectDailyTasksToSync);

  const handleCancel = () => {
    setVisible(false);
  };

  const handleSubmit = () => {
    dispatch(clearTasksToSync());
    toast.info("Cleared tasks to sync");
    setVisible(false);
  };

  return (
    <Dialog open={visible} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm the action</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={handleCancel}>
          <IoMdClose />
        </IconButton>
      </Box>
      <DialogContent>
        <Typography variant="body1" color="textSecondary">
          Are you sure want to clear non-synced completed tasks? (
          {tasksToSync.length})
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          size="medium"
          color="secondary"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="medium"
          color="warning"
          endIcon={<VscSyncIgnored />}
          onClick={handleSubmit}
        >
          Clear tasks to sync
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClearSyncDialog;
